module.exports = __webpack_public_path__ + "static/media/text.8a6079a3.svg";